import { authRoles } from 'app/auth';

import PlusWebsitesLayout from './layouts/PlusWebsitesLayout';
import ContentTab from './use-cases/Content/ContentTab';
import CreateSectionPage from './use-cases/Content/Pages/Section/Create/CreateSectionPage';
import CreateWebsiteSectionPage from './use-cases/Content/HeaderAndFooter/Section/Create/CreateWebsiteSectionPage';
import EditWebsiteSectionPage from './use-cases/Content/HeaderAndFooter/Section/Edit/EditWebsiteSectionPage';
import EditSectionPage from './use-cases/Content/Pages/Section/Edit/EditSectionPage';
import PageDetailsPage from './use-cases/Content/Pages/PageDetailsPage';
import SeoSettingsPage from './use-cases/Content/Pages/SeoSettings/SeoSettingsPage';
import FullScreenPreviewPage from './use-cases/Preview/FullScreenPreviewPage';
import ThemeAndStylesTab from './use-cases/ThemeAndStyles/ThemeAndStylesTab';
import SalesPage from './use-cases/Onboarding/SalesPage';
import StepsOverviewPage from './use-cases/Onboarding/StepsOverviewPage';
import BrandColourStep from './use-cases/Onboarding/BrandColourStep';
import LogoUploadStep from './use-cases/Onboarding/LogoUploadStep';
import PreviewStep from './use-cases/Onboarding/PreviewStep';
import HomePageStep from './use-cases/Onboarding/HomePageStep';
import DomainStep from './use-cases/Onboarding/DomainStep';
import SuccessPage from './use-cases/Onboarding/SuccessPage';
import OnboardingOutlet from './use-cases/Onboarding/OnboardingOutlet';
import { ONBOARDING_SEGMENTS } from './use-cases/Onboarding/constants/paths';
import LogoEditPage from './use-cases/ThemeAndStyles/Logo/LogoEditPage';
import BrandPaletteEditPage from './use-cases/ThemeAndStyles/BrandPalette/BrandPaletteEditPage';
import FaviconEditPage from './use-cases/ThemeAndStyles/Favicon/FaviconEditPage';
import AdminSettingsTab from './use-cases/AdminSettings/AdminSettingsTab';

const PlusWebsitesConfig = {
  settings: {
    layout: {
      config: {
        footer: {
          display: false,
        },
        healtheraHeader: {
          display: true,
          options: {
            organisationSelector: true,
            background: 'marketing',
          },
        },
      },
    },
  },
  // Every pharmacy user reaches the builder in both regions. The API keeps writes to
  // account_manager and support, so a plain pharmacist can browse and preview without being able
  // to change the live site.
  auth: authRoles.pharmacist,
  routes: [
    {
      path: 'plus-websites',
      element: <PlusWebsitesLayout />,
      children: [
        { path: '', element: <ContentTab /> },
        { path: 'theme-and-styles', element: <ThemeAndStylesTab /> },
        { path: 'admin-settings', element: <AdminSettingsTab /> },
      ],
    },
    {
      path: 'plus-websites/theme-and-styles/logo',
      element: <LogoEditPage />,
      settings: {
        layout: {
          config: {
            footer: { display: false },
            healtheraHeader: {
              display: true,
              options: { organisationSelector: false, background: 'marketing' },
            },
          },
        },
      },
    },
    {
      path: 'plus-websites/theme-and-styles/brand-palette',
      element: <BrandPaletteEditPage />,
      settings: {
        layout: {
          config: {
            footer: { display: false },
            healtheraHeader: {
              display: true,
              options: { organisationSelector: false, background: 'marketing' },
            },
          },
        },
      },
    },
    {
      path: 'plus-websites/theme-and-styles/favicon',
      element: <FaviconEditPage />,
      settings: {
        layout: {
          config: {
            footer: { display: false },
            healtheraHeader: {
              display: true,
              options: { organisationSelector: false, background: 'marketing' },
            },
          },
        },
      },
    },
    {
      path: 'plus-websites/pages/:pageId',
      element: <PageDetailsPage />,
      settings: {
        layout: {
          config: {
            footer: {
              display: false,
            },
            healtheraHeader: {
              display: true,
              options: {
                organisationSelector: false,
                background: 'marketing',
              },
            },
          },
        },
      },
    },
    {
      path: 'plus-websites/pages/:pageId/seo-settings',
      element: <SeoSettingsPage />,
      settings: {
        layout: {
          config: {
            footer: { display: false },
            healtheraHeader: {
              display: true,
              options: { organisationSelector: false, background: 'marketing' },
            },
          },
        },
      },
    },
    {
      path: 'plus-websites/pages/:pageId/sections/create',
      element: <CreateSectionPage />,
      settings: {
        layout: {
          config: {
            footer: {
              display: false,
            },
            healtheraHeader: {
              display: true,
              options: {
                organisationSelector: false,
                background: 'marketing',
              },
            },
          },
        },
      },
    },
    {
      path: 'plus-websites/sections/create',
      element: <CreateWebsiteSectionPage />,
      settings: {
        layout: {
          config: {
            footer: {
              display: false,
            },
            healtheraHeader: {
              display: true,
              options: {
                organisationSelector: false,
                background: 'marketing',
              },
            },
          },
        },
      },
    },
    {
      path: 'plus-websites/sections/:sectionId/edit',
      element: <EditWebsiteSectionPage />,
      settings: {
        layout: {
          config: {
            footer: { display: false },
            healtheraHeader: {
              display: true,
              options: { organisationSelector: false, background: 'marketing' },
            },
          },
        },
      },
    },
    {
      path: 'plus-websites/onboarding',
      element: <OnboardingOutlet />,
      settings: {
        layout: {
          config: {
            footer: { display: false },
            healtheraHeader: {
              display: true,
              options: { organisationSelector: true, background: 'marketing' },
            },
          },
        },
      },
      children: [
        { index: true, element: <SalesPage /> },
        { path: ONBOARDING_SEGMENTS.steps, element: <StepsOverviewPage /> },
        { path: ONBOARDING_SEGMENTS.colour, element: <BrandColourStep /> },
        { path: ONBOARDING_SEGMENTS.logo, element: <LogoUploadStep /> },
        { path: ONBOARDING_SEGMENTS.preview, element: <PreviewStep /> },
        { path: ONBOARDING_SEGMENTS.homepage, element: <HomePageStep /> },
        { path: ONBOARDING_SEGMENTS.domain, element: <DomainStep /> },
        { path: ONBOARDING_SEGMENTS.success, element: <SuccessPage /> },
      ],
    },
    {
      path: 'plus-websites/preview',
      element: <FullScreenPreviewPage />,
      settings: {
        layout: {
          config: {
            footer: { display: false },
            navbar: { display: false },
            toolbar: { display: false },
            healtheraHeader: { display: false },
          },
        },
      },
    },
    {
      path: 'plus-websites/pages/:pageId/sections/:sectionId/edit',
      element: <EditSectionPage />,
      settings: {
        layout: {
          config: {
            footer: {
              display: false,
            },
            healtheraHeader: {
              display: true,
              options: {
                organisationSelector: false,
                background: 'marketing',
              },
            },
          },
        },
      },
    },
  ],
};

export default PlusWebsitesConfig;
